<template>
  <div>
    <div class="row">
      <div class="col-12 mt-3">
        <Card body-classes="p-3" card-classes="shadow-sm">
          <template #header>
            <div class="d-flex flex-row align-items-center justify-content-between">
              <h5 class="mb-0 text-primary">
                <vue-feather type="bar-chart-2" class="me-2"></vue-feather>
                Product Sales with Stock Report - {{ store.name }}
              </h5>
              <div class="d-flex align-items-center gap-3">
                <div class="d-flex align-items-center">
                  <label for="fromDate" class="me-2 text-muted">From:</label>
                  <input type="date" id="fromDate" class="form-control form-control-sm" v-model="fromDate">
                </div>
                <div class="d-flex align-items-center">
                  <label for="toDate" class="me-2 text-muted">To:</label>
                  <input type="date" id="toDate" class="form-control form-control-sm" v-model="toDate">
                </div>
                <button class="btn btn-primary btn-sm" @click="getReport">
<!--                  <vue-feather type="search" size="16" class="me-1 mt-1"></vue-feather>-->
                  Generate Report
                </button>
              </div>
            </div>
          </template>
          <div>
            <div v-if="loading" class="text-center py-5">
              <Spinner spinner-class="mb-1" />
              <p class="text-muted mt-2">Loading product sales with stock report...</p>
            </div>
            <div v-else-if="reportData.length > 0">
              <div class="row mb-3">
                <div class="col-md-3">
                  <div class="card shadow-sm">
                    <div class="card-body text-center">
                      <vue-feather type="dollar-sign" size="24" class="text-success mb-2"></vue-feather>
                      <h6 class="text-muted mb-1">Total Cash</h6>
                      <h4 class="mb-0 text-success">{{ formatNumber(totalCash) }}</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card shadow-sm">
                    <div class="card-body text-center">
                      <vue-feather type="smartphone" size="24" class="text-primary mb-2"></vue-feather>
                      <h6 class="text-muted mb-1">Total M-Pesa</h6>
                      <h4 class="mb-0 text-primary">{{ formatNumber(totalMpesa) }}</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card shadow-sm">
                    <div class="card-body text-center">
                      <vue-feather type="trending-up" size="24" class="text-info mb-2"></vue-feather>
                      <h6 class="text-muted mb-1">Total Revenue</h6>
                      <h4 class="mb-0 text-info">{{ formatNumber(totalRevenue) }}</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="card shadow-sm">
                    <div class="card-body text-center">
                      <vue-feather type="package" size="24" class="text-warning mb-2"></vue-feather>
                      <h6 class="text-muted mb-1">Total Qty Sold</h6>
                      <h4 class="mb-0 text-warning">{{ totalQuantitySold + ' pcs' }}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-3">
                  <div class="input-group">
                    <span class="input-group-text">
                      <vue-feather type="search" size="16"></vue-feather>
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search by SKU or Product Name..."
                      v-model="searchQuery"
                    >
                  </div>
                </div>
                <div class="col-md-2">
                  <select class="form-select" v-model="selectedCategory">
                    <option value="">All Categories</option>
                    <option v-for="category in categories" :key="category" :value="category">
                      {{ category }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2">
                  <select class="form-select" v-model="selectedStockStatus">
                    <option value="">All Stock Status</option>
                    <option value="in-stock">In Stock</option>
                    <option value="low-stock">Low Stock</option>
                    <option value="out-of-stock">Out of Stock</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <select class="form-select" v-model="sortByQuantity">
                    <option value="">Sort by Quantity Sold</option>
                    <option value="desc">Quantity Sold (High to Low)</option>
                    <option value="asc">Quantity Sold (Low to High)</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <button class="btn btn-outline-secondary w-100" @click="clearFilters">
<!--                    <vue-feather type="x" size="16" class="me-1"></vue-feather>-->
                    Clear
                  </button>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>SKU</th>
                      <th>Product Name</th>
                      <th>Category</th>
                      <th>Quantity Sold</th>
                      <th>Total Sales Amount</th>
                      <th>Current Stock</th>
                      <th>Stock Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in filteredReportData" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.sku || 'N/A' }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.category_name || 'N/A' }}</td>
                      <td>{{ item.quantity_sold + ' pcs' }}</td>
                      <td>{{ formatNumber(item.total_sales_amount) }}</td>
                      <td>{{ item.current_stock + ' pcs' }}</td>
                      <td>
                        <span :class="getStockStatusClass(item.current_stock)">
                          {{ getStockStatus(item.current_stock) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="alert alert-info">
              <vue-feather type="info" size="18" class="me-2"></vue-feather>
              No data available. Please select a date range and generate the report.
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import {decrypt} from "@/utils/crypto";
import analyticsService from "@/api/analyticsService";
import formatNumber from "@/utils/formatNumber";

export default {
  name: "ProductSalesWithStock",

  data(){
    return {
      profile: {},
      store: {},
      loading: false,
      fromDate: '',
      toDate: '',
      reportData: [],
      searchQuery: '',
      selectedCategory: '',
      selectedStockStatus: '',
      sortByQuantity: '',
    }
  },

  methods: {
    formatNumber,
    async getReport() {
      if (!this.fromDate || !this.toDate) {
        return;
      }

      this.loading = true;
      try {
        const params = {
          store_id: this.store.id,
          from: this.fromDate,
          to: this.toDate
        };

        const response = await analyticsService.getProductSalesWithStock(params);
        this.reportData = response || [];
      } catch(e) {
        console.error(e);
        this.reportData = [];
      } finally {
        this.loading = false;
      }
    },
    getStockStatus(stock) {
      if (stock === 0) return 'Out of Stock';
      if (stock < 10) return 'Low Stock';
      return 'In Stock';
    },
    getStockStatusClass(stock) {
      if (stock === 0) return 'badge bg-danger';
      if (stock < 10) return 'badge bg-warning';
      return 'badge bg-success';
    },
    setDefaultDates() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth();
      
      const firstDay = new Date(year, month, 1);
      const fromYear = firstDay.getFullYear();
      const fromMonth = String(firstDay.getMonth() + 1).padStart(2, '0');
      const fromDay = String(firstDay.getDate()).padStart(2, '0');
      
      const toYear = today.getFullYear();
      const toMonth = String(today.getMonth() + 1).padStart(2, '0');
      const toDay = String(today.getDate()).padStart(2, '0');

      this.fromDate = `${fromYear}-${fromMonth}-${fromDay}`;
      this.toDate = `${toYear}-${toMonth}-${toDay}`;
    },
    clearFilters() {
      this.searchQuery = '';
      this.selectedCategory = '';
      this.selectedStockStatus = '';
      this.sortByQuantity = '';
    }
  },

  computed: {
    filteredReportData() {
      let filtered = this.reportData;

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(item => {
          const sku = (item.sku || '').toLowerCase();
          const name = (item.name || '').toLowerCase();
          return sku.includes(query) || name.includes(query);
        });
      }

      if (this.selectedCategory) {
        filtered = filtered.filter(item => item.category_name === this.selectedCategory);
      }

      if (this.selectedStockStatus) {
        filtered = filtered.filter(item => {
          const stock = item.current_stock;
          if (this.selectedStockStatus === 'out-of-stock') return stock === 0;
          if (this.selectedStockStatus === 'low-stock') return stock > 0 && stock < 10;
          if (this.selectedStockStatus === 'in-stock') return stock >= 10;
          return true;
        });
      }

      if (this.sortByQuantity) {
        filtered = [...filtered].sort((a, b) => {
          const qtyA = parseFloat(a.quantity_sold || 0);
          const qtyB = parseFloat(b.quantity_sold || 0);
          return this.sortByQuantity === 'asc' ? qtyA - qtyB : qtyB - qtyA;
        });
      }

      return filtered;
    },
    categories() {
      const uniqueCategories = [...new Set(this.reportData.map(item => item.category_name).filter(Boolean))];
      return uniqueCategories.sort();
    },
    totalCash() {
      return this.filteredReportData.reduce((sum, item) => {
        const paymentMethods = (item.payment_methods || '').toLowerCase();
        if (paymentMethods.includes('cash')) {
          return sum + parseFloat(item.total_sales_amount || 0);
        }
        return sum;
      }, 0);
    },
    totalMpesa() {
      return this.filteredReportData.reduce((sum, item) => {
        const paymentMethods = (item.payment_methods || '').toLowerCase();
        if (paymentMethods.includes('mpesa') || paymentMethods.includes('m-pesa')) {
          return sum + parseFloat(item.total_sales_amount || 0);
        }
        return sum;
      }, 0);
    },
    totalRevenue() {
      return this.filteredReportData.reduce((sum, item) => {
        return sum + parseFloat(item.total_sales_amount || 0);
      }, 0);
    },
    totalQuantitySold() {
      return this.filteredReportData.reduce((sum, item) => {
        return sum + parseFloat(item.quantity_sold || 0);
      }, 0);
    }
  },

  created: async function () {
    this.profile = JSON.parse(decrypt(sessionStorage.getItem('profile')));
    this.store = JSON.parse(decrypt(sessionStorage.getItem('store')));
    this.setDefaultDates();
  }
}
</script>

<style scoped>
.table th {
  background-color: #f8f9fa;
  font-weight: 600;
}
</style>
